import React from "react";
import { useDrop } from "react-dnd";
import ReactTooltip from "react-tooltip";

// Utils
import items from "../../utils/items";
import RealtimeConnection from "../../utils/RealtimeConnection";
import Translate from "../../utils/Translate";

// Components
import DroppableContainer from "../draggable/DroppableContainer";
import DroppableLabel from "../draggable/DroppableLabel";

export default function Equipment({
	canEdit,
	el,
	cashCoinsCount,
	dispatch,
	regionIndex,
	index,
	coinsCount,
	alias,
	basicEquipmentLblCount,
	premiumEquipmentLblCount,
}) {
	const [{ isOver }, drop] = useDrop({
		accept: items.container,
		collect: (monitor) => ({
			isOver: monitor.isOver(),
		}),
		drop: (item) => {
			const obj = {
				regionIndex: regionIndex,
				alias: alias,
				name: index,
				coins: item.coins ? item.coins : [],
			};
			RealtimeConnection.addContainer(obj);
			return { success: true };
		},
	});

	const canDrop = canEdit ? drop : null;

	return (
		<div className="eq-block m-2">
			<div className="location-header">
				<p className="sm-header line-0 pb-2 pl-1 pt-1"><Translate alias="Board" word={el.name} /></p>
				<div
					data-tip
					data-for={"equipment_" + regionIndex}
					className="help-icon"
				>
					?
				</div>
				<ReactTooltip
					id={"equipment_" + regionIndex}
					place="top"
					type="dark"
					effect="solid"
				>
					<table style={{ width: "117px" }}>
						<tbody>
							<tr>
								<th style={{ textAlign: "left" }}>
									<Translate alias="Board" word="Basic" />
								</th>
								<td>5</td>
							</tr>
							<tr>
								<th style={{ textAlign: "left" }}>
									<Translate alias="Board" word="Superior" />
								</th>
								<td>10</td>
							</tr>
						</tbody>
					</table>
				</ReactTooltip>
			</div>

			<DroppableContainer
				canEdit={canEdit}
				containerDrop={canDrop}
				containerIsOver={isOver}
				regionIndex={regionIndex}
				hasContainer={el.hasContainer}
				cashCoinsCount={cashCoinsCount}
				name={el.name}
				fieldIndex={index}
				alias={alias}
				dispatch={dispatch}
				coins={el.coins}
				coinsCount={coinsCount}
				playerId={el.playerId}
				isObjectDragging={el.isObjectDragging}
				draggingObject={el.draggingObject}
				equipment={true}
			/>
			<DroppableLabel
				canEdit={canEdit}
				dropType={items.equipment}
				hasLabel={el.status === "" ? false : true}
				labelType={el.status}
				regionIndex={regionIndex}
				alias={alias}
				name={index}
				dispatch={dispatch}
				basicLblCount={basicEquipmentLblCount}
				premiumLblCount={premiumEquipmentLblCount}
			/>
		</div>
	);
}
